import { useCanvasViewersStore } from "./store/canvas-viewers-store";

// フォーカスモード中のオーバーレイ表示。
// 画面全体に対象ユーザーのカーソル色と同じ色のボーダーを描き、上部にラベルを表示する。
// クリックなどの能動操作で useFocusMode 側が自動解除するため、ここでは UI 表示のみ担当する。
export function FocusModeOverlay(): JSX.Element | null {
  const focusedUserId = useCanvasViewersStore((s) => s.focusedUserId);
  const focusedViewer = useCanvasViewersStore((s) =>
    s.focusedUserId ? s.viewers[s.focusedUserId] : undefined
  );

  if (!focusedUserId || !focusedViewer) return null;
  const color = focusedViewer.color;
  const displayName = focusedViewer.displayName;

  return (
    <div
      aria-live="polite"
      data-testid="focus-mode-overlay"
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 1000,
      }}
    >
      {/* 画面全体を囲うボーダー（厚さ 4px）。pointer-events を切ってキャンバス操作を阻害しない。 */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          border: `4px solid ${color}`,
          boxSizing: "border-box",
          pointerEvents: "none",
        }}
      />
      {/* 画面上部に「○○さんをフォーカス中」ラベルを表示する。 */}
      <div
        style={{
          position: "absolute",
          top: "16px",
          left: "50%",
          transform: "translateX(-50%)",
          padding: "6px 14px",
          borderRadius: "9999px",
          background: color,
          color: "#ffffff",
          fontSize: "12px",
          fontWeight: 600,
          letterSpacing: "0.04em",
          boxShadow: "var(--shadow-1)",
          pointerEvents: "none",
          whiteSpace: "nowrap",
        }}
      >
        {displayName} さんをフォーカス中
      </div>
    </div>
  );
}
